import React from 'react';
import { ToastContext, Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import PropTypes from 'prop-types';
import ActionOnRatesModal from './actionOnRatesModal';
import RateModel from '../../../../models/rateModel';

export function CategoryActionModal({ selectedRates, showModal = false, model, categories, onSave, onClose }) {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [{ event, organization }] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const mapToCategories = React.useCallback(category => ({ key: category.pk, text: category.name, value: category.pk }), []);

    const optionsCategories = React.useMemo(() => {
        if (!categories) {
            return null;
        }
        let firstOption = [
            {
                key: 'no_categoy',
                text: t('ticket.rates.infos.noCategories'),
                value: 'no_category'
            }
        ];

        return firstOption.concat(categories.map(mapToCategories));
    }, [categories, mapToCategories]);

    const addRatesToCategory = React.useCallback(
        categoryId => {
            setIsSubmitting(true);
            selectedRates.forEach(rate => {
                if (rate instanceof RateModel) {
                    //add key form_id , so that the backend does not delete the linked form
                    rate.form_id = rate.form;
                }

                rate.category = categoryId !== 'no_category' ? categoryId : null;
                rate.translations = { name: {} };
            });
            model
                .save(
                    selectedRates,
                    {
                        organizationId: organization.pk,
                        eventId: event ? event.id : null
                    },
                    { skip_chart_validation: true }
                )
                .then(() => {
                    toast.success(t(`ticket.rates.updateCategorySuccess`));
                    onSave();
                })
                .catch(e => {
                    toast.error(t(`ticket.rates.updateCategoryError`));
                })
                .finally(() => {
                    setIsSubmitting(false);
                    onClose();
                });
        },
        [selectedRates, organization, event, onSave, onClose]
    );

    return (
        <ActionOnRatesModal
            type="category"
            selectedId={selectedRates.length === 1 ? selectedRates[0].category : null}
            onSave={categoryId => addRatesToCategory(categoryId)}
            onClose={onClose}
            options={optionsCategories}
            showModal={showModal}
            title={t(`ticket.rates.addRatesCategory`)}
            isSubmitting={isSubmitting}
            tooltip={t('ticket.rates.categoryInformation')}
        />
    );
}

export function CategoryAction({ objects: selectedRates, withModal = true, onClick = () => {}, ...props }) {
    const [showModal, setShowModal] = React.useState(false);
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {withModal && showModal && <CategoryActionModal selectedRates={selectedRates} showModal={showModal} onClose={() => setShowModal(false)} {...props} />}
            <Dropdown.Item
                onClick={() => {
                    setShowModal(true);
                    onClick();
                }}
            >
                {t('ticket.rates.modifyCategory')}
            </Dropdown.Item>
        </React.Fragment>
    );
}

CategoryAction.propTypes = {
    objects: PropTypes.array, //required
    categories: PropTypes.array.isRequired,
    model: PropTypes.func,
    onSave: PropTypes.func.isRequired
};
